import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress CRA dev error overlay for transient R3F applyProps errors that
// originate from dev-mode JSX __source debug props. The app recovers itself
// and we don't want these benign errors to block the UI.
if (typeof window !== 'undefined') {
  const _error = console.error;
  console.error = (...args) => {
    const msg = args?.[0];
    const s = typeof msg === 'string' ? msg : (msg && msg.message) || '';
    if (s && (s.includes('R3F: Cannot set') || s.includes('Cannot convert undefined or null to object'))) {
      return; // swallow
    }
    return _error.apply(console, args);
  };
  window.addEventListener('error', (e) => {
    const m = e?.error?.message || e?.message || '';
    if (m.includes('R3F: Cannot set') || m.includes('Cannot convert undefined or null to object')) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
  window.addEventListener('unhandledrejection', (e) => {
    const m = e?.reason?.message || '';
    if (m.includes('R3F: Cannot set') || m.includes('Cannot convert undefined or null to object')) {
      e.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
